import {MOON_50} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Panel = styled.div`
  flex: 1 1 auto;
  height: 100%;
  background-color: ${MOON_50};
`;
Panel.displayName = 'S.Panel';

export const Spacer = styled.div`
  height: 16px;
`;
Spacer.displayName = 'S.Spacer';
